import { render } from "./PipedTitle.vue?vue&type=template&id=0b380ff3"
import script from "./PipedTitle.vue?vue&type=script&lang=js"
export * from "./PipedTitle.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__